export function setProducts (state, products) {
    state.products = products;
}
export function setProductsEquivalent (state, products_equivalent) {
    state.products_equivalent = products_equivalent;
}



// WEBPACK FOOTER //
// ./src/modules/products_equivalent/mutations.js